var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcProjects = function SvgIcProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.334 15.834a1.667 1.667 0 0 1-1.667 1.666H3.334a1.667 1.667 0 0 1-1.667-1.666V4.167A1.667 1.667 0 0 1 3.334 2.5H7.5L9.167 5h7.5a1.667 1.667 0 0 1 1.667 1.667v9.167Z"
  })));
};
export default SvgIcProjects;